import axios from "axios";
export const api = axios.create({
    baseURL: "/api",
    withCredentials: true,
});
api.interceptors.response.use((r) => r, (err) => {
    if (err.response?.status === 401) {
        // session expired — bounce to login (preserving where they were)
        const here = window.location.pathname + window.location.search;
        if (!window.location.pathname.startsWith("/login")) {
            window.location.href = `/login?from=${encodeURIComponent(here)}`;
        }
    }
    return Promise.reject(err);
});
